<template>
    <div v-scrollspy="'.dpp-detail'" class="dpp-bar bar">
        <mvtShifter type="2" v-if="dpp.isActive">
            <a v-scroll href="#propertyDetailPanel" class="active">About</a>
            <a v-scroll href="#propertySchedulePanel" v-if="dpp.isActive && !dpp.isRentals">{{dpp.openHouses && dpp.openHouses.length > 0 ? 'Open House' : 'Tour'}}</a>
            <a v-scroll href="#propertySchoolPanel">Schools</a>
            <a v-scroll href="#propertyMapPanel">Neighborhood</a>
            <a v-scroll href="#propertyPoiPanel">Places of interest</a>
            <a v-scroll href="#propertyCommutePanel" v-if="dpp.isActive">Commute</a>
            <a v-scroll href="#propertyMortgagePanel" v-if="componentMounted && !dpp.isRentals">Mortgage calculator</a>
            <a v-scroll href="#propertyEstimatePanel" v-if="!dpp.isRentals">Home value</a>
            <a v-scroll href="#propertyHistoryPanel" v-if="!hideHistory() && getPriceHistory && getPriceHistory.length">Property history</a>
            <a v-scroll href="#propertyMarketPanel" v-if="!dpp.hideMarketStatistics && !dpp.isRentals">Market statistics</a>
        </mvtShifter>
        <mvtShifter type="2" v-else>
            <a v-scroll href="#propertyDetailPanel" class="active">About</a>
            <a v-scroll href="#propertyEstimatePanel" v-if="!dpp.isRentals">Home value</a>
            <a v-scroll href="#propertyHistoryPanel" v-if="!hideHistory() && getPriceHistory && getPriceHistory.length">Property history</a>
            <a v-scroll href="#propertyMarketPanel" v-if="!dpp.hideMarketStatistics && !dpp.isRentals">Market statistics</a>
            <a v-scroll href="#propertyMortgagePanel" v-if="componentMounted && !dpp.isRentals">Mortgage calculator</a>
            <a v-scroll href="#propertySchoolPanel">Schools</a>
            <a v-scroll href="#propertyMapPanel">Neighborhood</a>
            <a v-scroll href="#propertyPoiPanel">Places of interest</a>
        </mvtShifter>
    </div>
</template>

<script src="./dpp-barnew.js"></script>
<style lang="scss">
@use "./dpp-barnew.scss" as *;
</style>
